import isHotkey from 'is-hotkey';

const WHITE_LIST_HOTKEYS = ['mod+a', 'mod+c', 'mod+z', 'mod+y', 'mod+shift+z', 'shift'];

export const onKeyDownReadOnly = (e: KeyboardEvent) => {
  const isValidKey = WHITE_LIST_HOTKEYS.some((whiteListKey) => isHotkey(whiteListKey, e));
  if (!isValidKey) {
    e.preventDefault();
  }
};
